import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { buildUrl } from 'submodules/engine-common/util';
import { EnvironmentDataService } from 'src/app/submodules/angular-common/environment-data.service';
import { httpOptions } from 'src/app/submodules/angular-common/http-util';

@Injectable()
export class HomeFormService {

    constructor(
        private _injector:Injector,
        private _httpClient: HttpClient,
    ) { }

    sendUserDataObs(firstName:string, lastName:string, email:string, mobileNumber:string): Observable<any> {
        return this._httpClient.post(
            buildUrl(
                this._injector.get(EnvironmentDataService).environment.getValue("endpoints.api"),
                ["v1","send-user-data"]
            ),
            {
                'first-name': firstName,
                'last-name': lastName,
                email : email,
                'mobile-number': mobileNumber
            },
            httpOptions());
    }

    sendUserData = async (firstName:string, lastName:string, email:string, mobileNumber:string) => this.sendUserDataObs(firstName,lastName,email,mobileNumber).toPromise()
}